import { useGameInfo } from "@/entities/game/lib/useGameInfo";
import { GameDetails } from "@/entities/game/ui/GameDetails";
import { GameLayout } from "@/widgets/layout";
import { AxiosError } from "axios";
import React from "react";
import { useParams } from "react-router-dom";
import styles from "./GameInfoPage.module.css";

export const GameInfoPage: React.FC = () => {
  const { gameSlug } = useParams<{ gameSlug: string }>();
  const {
    game,
    isLoading,
    error,
    handlePlayGame,
    handleGoBack,
    handleGoToGamesList,
  } = useGameInfo(gameSlug || "");

  if (!gameSlug) {
    return (
      <GameLayout>
        <div className={styles.loadingContainer}>
          <div className={styles.errorCard}>
            <h1 className={styles.errorTitle}>Ошибка</h1>
            <p className={styles.errorText}>ID игры не указан</p>
            <button
              onClick={handleGoBack}
              className={`${styles.button} ${styles.buttonGray}`}
            >
              Назад
            </button>
          </div>
        </div>
      </GameLayout>
    );
  }

  if (isLoading) {
    return (
      <GameLayout>
        <div className={styles.loadingContainer}>
          <div className={styles.loadingContent}>
            <div className={styles.loadingText}>
              Загрузка информации об игре...
            </div>
          </div>
        </div>
      </GameLayout>
    );
  }

  if (error) {
    const errorMessage = (() => {
      const axiosError = error as AxiosError;
      if (axiosError?.response?.status === 404) {
        return `Игра с ID "${gameSlug}" не найдена`;
      }
      return "Ошибка при загрузке информации об игре";
    })();

    return (
      <GameLayout>
        <div className={styles.container}>
          <div className={styles.errorCard}>
            <h1 className={styles.errorTitle}>Ошибка</h1>
            <p className={styles.errorText}>{errorMessage}</p>
            <div className={styles.buttons}>
              <button
                onClick={handleGoBack}
                className={`${styles.button} ${styles.buttonGray}`}
              >
                Назад
              </button>
              <button
                onClick={handleGoToGamesList}
                className={`${styles.button} ${styles.buttonBlue}`}
              >
                К списку игр
              </button>
            </div>
          </div>
        </div>
      </GameLayout>
    );
  }

  if (!game) {
    return (
      <GameLayout>
        <div className={styles.container}>
          <div className={styles.errorCard}>
            <h1 className={styles.errorTitle}>Игра не найдена</h1>
            <p className={styles.errorText}>
              Запрашиваемая игра не существует или была удалена
            </p>
            <button
              onClick={handleGoToGamesList}
              className={`${styles.button} ${styles.buttonBlue}`}
            >
              К списку игр
            </button>
          </div>
        </div>
      </GameLayout>
    );
  }

  return (
    <GameLayout>
      <div className={styles.content}>
        <GameDetails game={game} onPlayGame={handlePlayGame} />
      </div>
    </GameLayout>
  );
};
